import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Paper from '@material-ui/core/Paper'
import WellSelection from './WellSelection'
import * as yup from 'yup'
import { Formik, Field } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import ValidationErrors from '../../../validations/ValidationErrors'
import OligoSequence from '../Step2/OligoSequence'
import OligoSequenceMixedWell from '../Step2/OligoSequenceMixedWell'
import {
  usePlateSessionFieldMutation,
  usePlateTotalValidationMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { configContext } from '../DnaPlates'
import clsx from 'clsx'
import messages from '../../../messages'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@material-ui/core/Button'
import { useRouter, dnaPlatesRoute } from '@src/routes'
import {
  ActiveLinkTypeDnaplate,
  PlateProduct,
  Specifications,
  CountryCodes,
  USExportCountriesListFor384Well,
  minimumWellsExecptionCountries,
  australianCountries,
} from '../enum'
import DuplexWellDetails from '../Step2/DuplexWellDetails'
import CircleLoader from '@src/components/CircleLoader'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import OligoNameWarning from '../../../validations/oligoNameWarning'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    paddingTop: theme.spacing(6),
  },
  fullContainer: {
    padding: theme.spacing(4),
  },
  TextFontRes: {
    padding: theme.spacing(2, 0, 0, 4),
    fontWeight: theme.typography.fontWeightMedium,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  TextFont: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(5),
    color: '#1b1b25',
  },
  TextFontGrid: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  Checkbox: {
    marginTop: theme.spacing(-2),
    marginLeft: theme.spacing(35.5),
  },
  wellHeding: {
    color: '#1b1b25',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
  },
  marginBorder: {
    marginBottom: theme.spacing(1),
  },
  textPadTop: {
    paddingLeft: theme.spacing(5),
    color: '#1b1b25',
    fontWeight: theme.typography.fontWeightMedium,
  },
  marginTop: {
    marginTop: theme.spacing(-1),
  },
  researchTop: {
    marginTop: theme.spacing(2),
  },
  checkboxLabel: {
    fontWeight: 100,
    fontSize: theme.typography.pxToRem(14),
  },
  sequenceInput: {
    '&.Mui-error': {
      border: '0 none',
      borderBottom: `1px solid ${theme.palette.error.main}`,
    },
    '&.Mui-error:hover': {
      border: '0 none',
      borderBottom: `1px solid ${theme.palette.error.main}`,
    },
    '&.Mui-error.Mui-focused': {
      border: '0 none',
      borderBottom: `1px solid ${theme.palette.error.main}`,
    },
  },
  sequenceLabel: {
    '& label': {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  plateresearchName: {
    width: theme.spacing(52),
  },
  wellMargin: {
    textAlign: 'right',
    paddingRight: theme.spacing(10),
  },
  nextButton2: {
    float: 'right',
    paddingLeft: theme.spacing(177),
  },
  nextButton: {
    marginTop: theme.spacing(5),
    width: theme.spacing(50),
  },
  over1: {
    fontSize: theme.typography.pxToRem(14),
    color: '#1d5293',
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(2),
  },
  overrideCheckBox: {
    padding: theme.spacing(0),
  },
  warning: {
    padding: theme.spacing(0, 8.5, 0, 8.5),
  },
  colorRed: {
    color: theme.palette.error.main,
  },
  hideRow: {
    display: 'none',
  },
  errormsg: {
    margin: theme.spacing(2, 0, 0, 0),
    fontSize: theme.typography.pxToRem(13),
  },
  overrideroot: {
    marginRight: theme.spacing(0),
  },
  wellSectionHeading: {
    fontWeight: theme.typography.fontWeightBold,
  },
  WellSectionText: {
    padding: theme.spacing(2, 2, 2, 9),
  },
  namewarning: {
    borderLeft: `${theme.spacing(2)}px solid #F7A703`,
    fontSize: theme.typography.pxToRem(13),
  },
  message: {
    padding: theme.spacing(2.5, 2.5, 2.5, 2.5),
  },
}))

const PlateNames = (props) => {
  const { specificationsData, productDetails } = props
  const classes = useStyles()
  let [splChar] = React.useState<string>('')
  const [platesessionField] = usePlateSessionFieldMutation()
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, currentPlateIndex, isPageLoad, isPlateDeleted } = state
  const [validationPlateErrors, setValidationPlateErrors] = React.useState<
    string[]
  >(sessionData[currentPlateIndex].plateNameError)
  const [validationResearchErrors, setValidationResearchErrors] =
    React.useState<string[]>(sessionData[currentPlateIndex].researcherNameError)
  const [plateTotalValidation, { loading }] = usePlateTotalValidationMutation()
  const router = useRouter()
  const [isOverriden, setIsOverriden] = React.useState(
    sessionData[0].isOverridden
  )
  const intl = useIntl()
  const [reqPlate, setReqPlate] = React.useState(false)

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }
  //function to extract the special characters from the string passed
  const checkSpecialChar = (args): string => {
    splChar = ''
    args.value !== undefined &&
      args.value.split('').forEach((c) => {
        if (
          !c.match(/^[a-zA-Z0-9_#%&*()., +.:[\-\]/]*$/) &&
          !splChar.includes(c)
        ) {
          if (splChar === '') {
            splChar = c
          } else {
            splChar = splChar + ', ' + c
          }
        }
      })
    return splChar
  }
  let firstWell: any = []
  if (sessionData[currentPlateIndex].plateType !== 'STANDARD') {
    sessionData[currentPlateIndex].wellList.forEach((wells) => {
      if (wells.row === 'A' && wells.column === '1') {
        firstWell = firstWell.concat(wells)
      }
    })
  } else {
    firstWell = firstWell.concat(sessionData[currentPlateIndex].wellList[0])
  }

  const totalValidation = async () => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    let errorCount = 0
    if (data && !data.plateTotalValidation.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: data.plateTotalValidation.response,
      })
      data.plateTotalValidation.response.forEach((plate) => {
        if (productDetails.productType === PlateProduct.DuplexPlate) {
          plate.biTubeWellList.forEach((duplexwell) => {
            if (duplexwell.listError.length !== 0) {
              errorCount = errorCount + 1
            }
          })
        } else {
          plate.wellList.forEach((well) => {
            if (well.listError.length !== 0) {
              errorCount = errorCount + 1
            }
          })
        }
      })
      if (errorCount === 0) {
        dispatch({ type: 'SET_STEP_NO', data: 2 })
        const url = `${dnaPlatesRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkTypeDnaplate.Specifications}`
        router.push(url)
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        window.scrollTo(0, 0)
        sessionData.forEach((data) => {
          data.pageNo = 1
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        dispatch({ type: 'SET_STEP_NO', data: 1 })
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    savePlateDataToSession(sessionData)
  }

  const [openWellDetails, setOpenWellDetails] = React.useState(false)

  const goToNextStep = () => {
    let nameErrorCount = 0
    let minimumWells = false
    sessionData.forEach((data) => {
      if (
        data.plateNameError.length !== 0 ||
        data.researcherNameError.length !== 0
      ) {
        nameErrorCount = nameErrorCount + 1
      }
      if (isOverriden !== true) {
        if (productDetails.productType === PlateProduct.DuplexPlate) {
          if (data.biTubeWellList.length < 24) {
            minimumWells = true
          }
        } else {
          if (
            !(
              (data.wellType === PlateProduct.wellType &&
                USExportCountriesListFor384Well.includes(
                  productDetails.countryCode
                )) ||
              minimumWellsExecptionCountries.includes(
                productDetails.countryCode
              )
            )
          ) {
            if (productDetails.countryCode === CountryCodes.JP) {
              if (
                (data.plateType === Specifications.STANDARD &&
                  data.wellList.length < 48) ||
                (data.plateType === Specifications.MIXED &&
                  data.wellList.length < 96)
              ) {
                minimumWells = true
              }
            } else if (
              australianCountries.includes(productDetails.countryCode)
            ) {
              if (
                (data.plateType === Specifications.STANDARD &&
                  data.wellList.length < 40) ||
                (data.plateType === Specifications.MIXED &&
                  data.wellList.length < 80)
              ) {
                minimumWells = true
              }
            } else {
              if (
                (data.plateType === Specifications.STANDARD &&
                  data.wellList.length < 24) ||
                (data.plateType === Specifications.MIXED &&
                  data.wellList.length < 48)
              ) {
                minimumWells = true
              }
            }
          }
        }
      }
    })
    if (nameErrorCount !== 0 || minimumWells) {
      if (minimumWells) {
        dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: true })
        if (productDetails.productType === PlateProduct.DuplexPlate) {
          dispatch({
            type: 'SET_PAGE_ERROR',
            data: intl.formatMessage(messages.CONF_DNAPLATE_MINIMUM_WELLS_TEXT),
          })
        } else {
          if (productDetails.countryCode === CountryCodes.JP) {
            dispatch({
              type: 'SET_PAGE_ERROR',
              data: intl.formatMessage(
                messages.CONF_DNAPLATE_MINIMUM_WELLS_TEXT_JP
              ),
            })
          } else if (australianCountries.includes(productDetails.countryCode)) {
            dispatch({
              type: 'SET_PAGE_ERROR',
              data: intl.formatMessage(
                messages.CONF_DNAPLATE_MINIMUM_WELLS_TEXT_AUSTRALIAN_COUNTRIES
              ),
            })
          } else {
            dispatch({
              type: 'SET_PAGE_ERROR',
              data: intl.formatMessage(
                messages.CONF_DNAPLATE_MINIMUM_WELLS_TEXT
              ),
            })
          }
        }
      } else {
        dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
      }
      window.scrollTo(0, 0)
    } else {
      dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
      sessionData.forEach((plate) => {
        plate.pageNo = 2
        if (productDetails.productType === PlateProduct.DuplexPlate) {
          plate.biTubeWellList.forEach((well) => {
            if (well.isOverridden !== true) {
              well.pageNo = 2
            } else {
              well.pageNo = 0
            }
          })
        } else {
          plate.wellList.forEach((well) => {
            if (well.isOverridden !== true) {
              well.pageNo = 2
            } else {
              well.pageNo = 0
            }
          })
        }
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      totalValidation()
    }
  }

  const [well, setWell] = React.useState(firstWell)
  const [row, setRow] = React.useState('')
  const [col, setCol] = React.useState('')
  const [plateName, setPlateName] = React.useState<string>(
    sessionData[currentPlateIndex].plateName
  )
  const [name, setName] = React.useState<string>(
    sessionData[currentPlateIndex].plateName
  )
  const [researchName, setResearchName] = React.useState<string>(
    sessionData[currentPlateIndex].researcher
  )
  const [apply, setApply] = React.useState<boolean>(
    sessionData[currentPlateIndex].applyToAll
  )
  const [saveToSession, setSaveToSession] = React.useState(false)

  React.useEffect(() => {
    setPlateName(sessionData[currentPlateIndex].plateName)
    setResearchName(sessionData[currentPlateIndex].researcher)
    setApply(sessionData[currentPlateIndex].applyToAll)
    setName(sessionData[currentPlateIndex].plateName)
    setValidationPlateErrors(sessionData[currentPlateIndex].plateNameError)
    setValidationResearchErrors(
      sessionData[currentPlateIndex].researcherNameError
    )
    setOpenWellDetails(false)
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPlateIndex, isPlateDeleted])

  React.useEffect(() => {
    if (isPageLoad) {
      setPlateName(sessionData[currentPlateIndex].plateName)
      setResearchName(sessionData[currentPlateIndex].researcher)
      setApply(sessionData[currentPlateIndex].applyToAll)
      setName(sessionData[currentPlateIndex].plateName)
      setValidationPlateErrors(sessionData[currentPlateIndex].plateNameError)
      setValidationResearchErrors(
        sessionData[currentPlateIndex].researcherNameError
      )
      setOpenWellDetails(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLoad])

  const oligoNameWarning = () => {
    let count = false
    if (productDetails.productType === PlateProduct.DuplexPlate) {
      sessionData[currentPlateIndex].biTubeWellList.forEach((data) => {
        if (
          (data.name.trim().length > 18 && data.name.trim().length <= 27) ||
          (data.antisenceName.trim().length > 18 &&
            data.antisenceName.trim().length <= 30)
        ) {
          count = true
        }
      })
    } else {
      sessionData[currentPlateIndex].wellList.forEach((data) => {
        if (data.name.trim().length > 18 && data.name.trim().length <= 30) {
          count = true
        }
      })
    }
    return count
  }

  React.useEffect(() => {
    if (saveToSession) {
      if (plateName === undefined) {
        sessionData[currentPlateIndex].plateName = name.trim()
        if (reqPlate) {
          const errors: string[] = []
          errors.push(intl.formatMessage(messages.CONF_REQUIRED_FIELD))
          sessionData[currentPlateIndex].plateNameError = errors
        } else {
          sessionData[currentPlateIndex].plateNameError = validationPlateErrors
        }
      } else {
        sessionData[currentPlateIndex].plateName = plateName.trim()
        if (reqPlate) {
          const errors: string[] = []
          errors.push(intl.formatMessage(messages.CONF_REQUIRED_FIELD))
          sessionData[currentPlateIndex].plateNameError = errors
        } else {
          sessionData[currentPlateIndex].plateNameError = validationPlateErrors
        }
      }
      if (researchName !== undefined) {
        if (apply === true) {
          sessionData.forEach((data) => {
            data.researcher = researchName
            data.researcherNameError = validationResearchErrors
          })
        } else {
          sessionData[currentPlateIndex].researcher = researchName
          sessionData[currentPlateIndex].researcherNameError =
            validationResearchErrors
        }
      } else {
        if (apply === true) {
          sessionData.forEach((data) => {
            data.researcher = ''
            data.researcherNameError = validationResearchErrors
          })
        } else {
          sessionData[currentPlateIndex].researcher = ''
          sessionData[currentPlateIndex].researcherNameError =
            validationResearchErrors
        }
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      savePlateDataToSession(sessionData)
      setSaveToSession(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveToSession])

  const populateData = (well, row, col) => {
    setWell(well)
    setRow(row)
    setCol(col)
    setOpenWellDetails(true)
    window.scrollTo(0, 800)
  }

  const handleApplysToAll = (value) => {
    setApply(value)
    sessionData.forEach((data) => {
      data.applyToAll = value
      data.pageNo = 1
    })
    dispatch({ type: 'SET_STEP_NO', data: 1 })
    setSaveToSession(true)
  }
  const handleNameChange = (value) => {
    setPlateName(value)
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setSaveToSession(true)
    sessionData.forEach((data) => {
      data.pageNo = 1
    })
    dispatch({ type: 'SET_STEP_NO', data: 1 })
    if (value?.length === 0 || value?.length === value?.split(' ').length - 1) {
      setReqPlate(true)
    } else {
      setReqPlate(false)
    }
  }

  const handleResearchName = (value) => {
    setResearchName(value)
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setSaveToSession(true)
    sessionData.forEach((data) => {
      data.pageNo = 1
    })
    dispatch({ type: 'SET_STEP_NO', data: 1 })
  }

  const overrideValidation = async () => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.plateTotalValidation.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      data.plateTotalValidation.response.forEach((plate, index) => {
        if (productDetails.productType === PlateProduct.DuplexPlate) {
          plate.biTubeWellList.forEach((duplexwell, dulexWellIndex) => {
            duplexwell.listError.forEach((error) => {
              delete error.__typename
            })
            sessionData[index].biTubeWellList[dulexWellIndex].listError =
              duplexwell.listError
          })
        } else {
          plate.wellList.forEach((well, wellIndex) => {
            well.listError.forEach((error) => {
              delete error.__typename
            })
            sessionData[index].wellList[wellIndex].listError = well.listError
          })
        }
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    savePlateDataToSession(sessionData)
  }

  const handleOverride = (value) => {
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setIsOverriden(value)
    sessionData.forEach((plate) => {
      plate.isOverridden = value
      plate.pageNo = 1
      if (productDetails.productType === PlateProduct.DuplexPlate) {
        plate.biTubeWellList.forEach((duplexwell) => {
          duplexwell.isOverridden = value
        })
      } else {
        plate.wellList.forEach((well) => {
          well.isOverridden = value
        })
      }
    })
    dispatch({ type: 'SET_STEP_NO', data: 1 })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    setOpenWellDetails(false)
    overrideValidation()
  }

  const updatedData = () => {
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setOpenWellDetails(false)
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }

  const wellType = sessionData[currentPlateIndex].wellType
  const channelType = sessionData[currentPlateIndex].channelType
  const plateType =
    sessionData[currentPlateIndex].plateType === Specifications.STANDARD ? (
      <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
    ) : (
      <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_MIXED} />
    )
  return (
    <Box>
      <Formik
        initialValues={{}}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        {() => (
          <>
            <div>
              <Paper>
                <Grid container className={classes.root}>
                  <Grid item xs={5} sm={5}>
                    <div>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={5}
                          sm={5}
                          className={classes.TextFontGrid}
                        >
                          <FormLabel className={classes.TextFont}>
                            <FormattedMessage
                              {...messages.CONF_DNAPLATES_PLATE_NAME}
                            />{' '}
                          </FormLabel>
                        </Grid>
                        <Grid item xs={7} sm={7} className={classes.marginTop}>
                          <Field
                            name="plateName"
                            size="small"
                            fullWidth={false}
                            component={LiquidInputAdapter}
                            value={plateName}
                            filled
                            validate={(value) => {
                              handleNameChange(value)
                              const val = checkSpecialChar({ value })
                              const validator = yup
                                .string()
                                .trim()
                                .max(30, 'Maximum character length is 30')
                                .matches(
                                  /^[a-zA-Z0-9_#%&*()., +.:[\-\]/]*$/,
                                  'Name contains invalid character(s):' + val
                                )
                              const errors: string[] = []
                              try {
                                setValidationPlateErrors([])
                                validator.validateSync(value, {
                                  abortEarly: false,
                                })
                              } catch (error: any) {
                                for (const err of error.errors) {
                                  errors.push(err)
                                }
                                setValidationPlateErrors(errors)
                              }
                              return null
                            }}
                            className={clsx(
                              classes.sequenceInput,
                              classes.plateresearchName
                            )}
                          />
                          <ValidationErrors errors={validationPlateErrors} />
                          <Grid className={reqPlate ? '' : classes.hideRow}>
                            <div
                              className={clsx(
                                classes.colorRed,
                                classes.errormsg
                              )}
                            >
                              <FormattedMessage
                                {...messages.CONF_REQUIRED_FIELD}
                              />
                            </div>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xs={5}
                          sm={5}
                          className={classes.researchTop}
                        >
                          <FormLabel className={classes.textPadTop}>
                            <FormattedMessage
                              {...messages.CONF_DNAPLATES_RESEARCHER}
                            />{' '}
                          </FormLabel>
                        </Grid>
                        <Grid item xs={7} sm={7}>
                          <Field
                            name="researchName"
                            component={LiquidInputAdapter}
                            size="small"
                            fullWidth={false}
                            filled
                            value={researchName}
                            validate={(value) => {
                              handleResearchName(value)
                              const val = checkSpecialChar({ value })
                              const validator = yup
                                .string()
                                .max(30, 'Maximum character length is 30')
                                .matches(
                                  /^[a-zA-Z0-9_#%&*()., +.:[\-\]/]*$/,
                                  'Name contains invalid character(s):' + val
                                )
                              const errors: string[] = []
                              try {
                                setValidationResearchErrors([])
                                validator.validateSync(value, {
                                  abortEarly: false,
                                })
                              } catch (error: any) {
                                for (const err of error.errors) {
                                  errors.push(err)
                                }
                                setValidationResearchErrors(errors)
                              }
                              return null
                            }}
                            className={clsx(
                              classes.sequenceInput,
                              classes.plateresearchName
                            )}
                            inputProps={{
                              'data-scrub': 'true',
                            }}
                          />
                          <ValidationErrors errors={validationResearchErrors} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          {currentPlateIndex === 0 &&
                          PlateProduct.DuplexPlate !==
                            productDetails.productType ? (
                            <FormControlLabel
                              classes={{ label: classes.checkboxLabel }}
                              className={classes.Checkbox}
                              control={
                                <Checkbox
                                  checked={apply}
                                  color="primary"
                                  value={apply}
                                  onChange={() => {
                                    handleApplysToAll(!apply)
                                  }}
                                />
                              }
                              label="Apply to all Plates"
                            />
                          ) : (
                            ''
                          )}
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4} className={classes.wellMargin}>
                    <span className={classes.wellHeding}>
                      <FormattedMessage
                        {...messages.CONF_DNAPLATE_CONFIGURATION_WELL_TEXT}
                        values={{ wellType, channelType, plateType }}
                      />
                    </span>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    {productDetails.isCSRSupervisor === true ? (
                      <FormControlLabel
                        classes={{
                          label: classes.over1,
                          root: classes.overrideroot,
                        }}
                        control={
                          <Checkbox
                            value={isOverriden}
                            color="primary"
                            checked={isOverriden}
                            onChange={() => {
                              handleOverride(!isOverriden)
                            }}
                            className={classes.overrideCheckBox}
                          />
                        }
                        label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
                      />
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
                <Grid className={classes.WellSectionText}>
                  {productDetails.productType === PlateProduct.DuplexPlate ? (
                    <>
                      <div className={classes.wellSectionHeading}>
                        <FormattedMessage
                          {...messages.CONF_DUPLEXPLATE_WELLSECTION_HEAD_TEXT}
                        />
                        {plateName}
                      </div>
                      <div>
                        <FormattedMessage
                          {...messages.CONF_DUPLEXPLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={classes.wellSectionHeading}>
                        <FormattedMessage
                          {...messages.CONF_DNAPLATE_WELLSECTION_HEAD_TEXT}
                        />
                        {plateName}
                      </div>
                      <div>
                        <FormattedMessage
                          {...messages.CONF_PLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT}
                        />
                      </div>
                    </>
                  )}
                </Grid>
                {oligoNameWarning() ? (
                  <Grid className={classes.WellSectionText}>
                    {
                      <OligoNameWarning
                        warning={intl.formatMessage(
                          messages.CONF_OLIGO_NAME_PLATE_WARNING
                        )}
                      />
                    }
                  </Grid>
                ) : (
                  ''
                )}
                <WellSelection
                  populateData={populateData}
                  sessionData={sessionData[currentPlateIndex]}
                  productDetails={productDetails}
                  onWellclick={openWellDetails}
                />
              </Paper>
              {sessionData[currentPlateIndex].plateType ===
              Specifications.STANDARD ? (
                row !== '' && col !== '' && openWellDetails === true ? (
                  productDetails.productType === PlateProduct.DuplexPlate ? (
                    <DuplexWellDetails
                      specificationsData={specificationsData}
                      well={well}
                      row={row}
                      col={col}
                      productDetails={productDetails}
                      updatedData={updatedData}
                    />
                  ) : (
                    <OligoSequence
                      specificationsData={specificationsData}
                      well={well}
                      row={row}
                      col={col}
                      productDetails={productDetails}
                      updatedData={updatedData}
                    />
                  )
                ) : (
                  ''
                )
              ) : row !== '' &&
                col !== '' &&
                openWellDetails === true &&
                sessionData[currentPlateIndex].plateType !== '' ? (
                <OligoSequenceMixedWell
                  specificationsData={specificationsData}
                  well={well}
                  row={row}
                  col={col}
                  productDetails={productDetails}
                  updatedData={updatedData}
                />
              ) : (
                ''
              )}
              <Grid className={classes.nextButton2}>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  onClick={goToNextStep}
                  className={classes.nextButton}
                  id="plates-continue-button-1"
                  data-testid="plates-continue-button-1"
                >
                  <FormattedMessage {...messages.CONF_CONTINUE_DNA_PLATES} />
                </Button>
              </Grid>
            </div>
          </>
        )}
      </Formik>
      {loading && <CircleLoader />}
    </Box>
  )
}

export default PlateNames
